// ======================================================================
// File Name       : box
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { STRUCTURE_LEVEL } from '../../constants';

export function postBoxEditDisplayOrder(data) {
  return commonCallApi({
    path: 'box/EditDisplayOrder',
    data,
  });
}

export function postBoxGetList(data) {
  return commonCallApi({
    path: 'box/GetList',
    data,
  });
}

export function postBoxEdit(editType, data) {
  return commonCallApi({
    path: 'box/Edit',
    data: {
      editType,
      boxInfo: data,
    },
  });
}
